import { AnyAction, combineReducers } from 'redux';

import { CONTACT_DETAIL_RESET } from './contact-detail-global-actions';
import {
    ContactDetailDocumentsReducerState,
    contactDetailDocumentsReducer,
} from '../documents/store/contact-detail-documents-reducer';
import { ContactDetailGlobalReducerState, contactDetailGlobalReducer } from './contact-detail-global-reducer';
import {
    ContactDetailOverviewReducerState,
    contactDetailOverviewReducer,
} from '../overview/store/contact-detail-overview-reducers';
import {
    ContactDetailPermissionsReducerState,
    contactDetailPermissionsReducer,
} from '../permissions/store/contact-detail-permissions-reducer';

export interface ContactDetailReducerState {
    global: ContactDetailGlobalReducerState;
    overview: ContactDetailOverviewReducerState;
    permissions: ContactDetailPermissionsReducerState;
    documents: ContactDetailDocumentsReducerState;
}

const combinedContactDetailReducer = combineReducers<ContactDetailReducerState>({
    global: contactDetailGlobalReducer,
    overview: contactDetailOverviewReducer,
    permissions: contactDetailPermissionsReducer,
    documents: contactDetailDocumentsReducer,
});

const initialContactDetailReducerState: ContactDetailReducerState = combinedContactDetailReducer(undefined, {
    type: '',
});

export const contactDetailReducer = (
    state: ContactDetailReducerState = initialContactDetailReducerState,
    action: AnyAction
): ContactDetailReducerState => {
    switch (action.type) {
        case CONTACT_DETAIL_RESET:
            return combinedContactDetailReducer(undefined, action);
        default:
            return combinedContactDetailReducer(state, action);
    }
};
